<template>
  <span v-if="checkCount > 0">
    <span
      class="
        tw-inline-flex tw-items-center tw-gap-1
        2xl:tw-hidden
        tw-rounded-lg tw-bg-sf-primary-subtle tw-p-2
        sf-pointer
      "
      @click.stop.prevent="openSidepane"
    >
      <i class="tw-text-sf-primary-dark icon icon-magic"></i>
      <span class="tw-text-sm tw-font-sans">{{ checkCount }}</span>
    </span>
    <span class="tw-hidden tw-text-sf-gray 2xl:tw-inline-flex">
      <sf-banner-inline
        icon-class="icon-magic"
        variant="info"
        :hoverable="true"
        :title="fullTitle"
        @click.stop.prevent="openSidepane"
      >
        <template #actions>
          <i class="icon icon-chevron-right"></i>
        </template>
      </sf-banner-inline>
    </span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SfBannerInline from '../../../shared/vue/components/sf-banner/sf-banner-inline.vue'
import { storeToRefs } from 'pinia'
import { useChecksStore } from '@app/application/sf-assistant-checks/stores/checks'
import useSfAssistantChecks from '@app/application/sf-assistant-checks/composables/use-sf-assistant-checks'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfAssistantChecksBanner',
})

const checksStore = useChecksStore()
useSfAssistantChecks()

const { visibleChecks } = storeToRefs(checksStore)

const checkCount = computed(() => visibleChecks.value.length)

const fullTitle = computed(() => {
  return window.I18n.t('account_entry.assistant.banner.title', {
    count: checkCount.value,
  })
})

function openSidepane(): void {
  window.eventHub.$emit('resetCommunicationFilter')
  window.eventHub.$emit('openSidepane')
}
</script>
